/* RESPONSIBLE TEAM: team-proactive-support */
import { attr } from '@ember-data/model';
import Fragment from 'ember-data-model-fragments/fragment';

export default class Translation extends Fragment {
  @attr('string') localeId;
  @attr('string') name;
}
